<template>
  <div
    id="menu-container"
    class="menu-list"
    :style="custom_style"
    v-if="open_menu"
  >
  <div class="slot-item">
    <slot name="header"></slot>
  </div>
    <div
      v-for="(menu_item, index) in menu_items"
      :class="[
        'menu-item',
        { active: selected_item === menu_item ? true : false },
      ]"
      :key="index"
      @click.stop="select_item(menu_item)"
    >
      {{ menu_item }}
    </div>
  </div>
</template>

<script>
export default {
  name: "common-menu",
  emits: ["select_item"],
  props: ["custom_style", "open_menu", "menu_items", "selected_item"],
  methods: {
    select_item(menu_item) {
      this.$emit("select_item", menu_item);
    },
  },
};
</script>

<style scoped>
.slot-item {
    margin-bottom: 5px; border-radius: 7px 7px 0 0; background-color:#efeeed;
    box-shadow: inset 0px -2px 5px #e2e1e1;
  }

.menu-list {
  position: absolute;
  width: 150px;
  top: 35px;
  right: 0;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 3px 6px #0000004d;
  padding: 5px;
  z-index: 99999;
}

.menu-item {
  padding: 5px;
  margin-bottom: 2px;
  border-radius: 8px;
  color: #111111;
  font-size: 15px;
  cursor: pointer;
}

.menu-item:hover {
  font-weight: bold;
}

</style>